import { LOGIN_MODAL_OPEN, SET_LOGIN_MODAL_STORE_DATA } from '../action-types/login.action-types';

export type LoginReducer = {
  isLoginModalOpen: boolean;
  redirect: string;
  storeData?: any;
};

const initialState: LoginReducer = {
  isLoginModalOpen: false,
  redirect: null,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_MODAL_OPEN: {
      return {
        ...state,
        isLoginModalOpen: action.data?.isOpen,
        redirect: action.data?.isOpen ? action.data?.redirect : null,
        referralCode: action.data?.referralCode,
      };
    }
    case SET_LOGIN_MODAL_STORE_DATA: {
      return {
        ...state,
        storeData: action.data?.storeData,
      };
    }
    default: {
      return state;
    }
  }
};

export default loginReducer;
